import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CONTACT_US_ADDRESS_MAIN, CONTACT_US_EMAIL_MAIN, CONTACT_US_PHONE_MAIN, CONTACT_US_WHATSAPP_MAIN, SOCIAL_LINK_FACEBOOK, SOCIAL_LINK_INSTAGRAM, SOCIAL_LINK_LINKEDIN, SOCIAL_LINK_TIKTOK, SOCIAL_LINK_TWITTER, SOCIAL_LINK_YOUTUBE } from '../../shared/constants';
import { NewsletterSubsFormComponent } from "../../components/newsletter-subs-form/newsletter-subs-form.component";

@Component({
    selector: 'app-footer',
    imports: [
    RouterModule,
    NewsletterSubsFormComponent
],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  CONTACT_US_ADDRESS_MAIN: string = CONTACT_US_ADDRESS_MAIN;
  CONTACT_US_EMAIL_MAIN: string = CONTACT_US_EMAIL_MAIN;
  CONTACT_US_PHONE_MAIN: string = CONTACT_US_PHONE_MAIN;
  CONTACT_US_WHATSAPP_MAIN: string = CONTACT_US_WHATSAPP_MAIN;

  SOCIAL_LINK_FACEBOOK: string = SOCIAL_LINK_FACEBOOK
  SOCIAL_LINK_INSTAGRAM: string = SOCIAL_LINK_INSTAGRAM
  SOCIAL_LINK_LINKEDIN: string = SOCIAL_LINK_LINKEDIN
  SOCIAL_LINK_TIKTOK: string = SOCIAL_LINK_TIKTOK
  SOCIAL_LINK_TWITTER: string = SOCIAL_LINK_TWITTER
  SOCIAL_LINK_YOUTUBE: string = SOCIAL_LINK_YOUTUBE

  currentYear = new Date().getFullYear()
}
